import React from "react";
import { observer } from "mobx-react";
import { Path } from "../../models/router";
import { L10n } from "@fidget/common/i18n";
import styles from "../settings/settingsNavigation.css";
import { NavigationButton } from "../../components/navigationButton";
import { DashboardView } from "../dashboard/views/DashboardView";

interface Props {
  view: DashboardView;
}

export const AiSuggestionNavigation = observer(({ view }: Props) => (
  <div className={styles["navigation-container"]}>
    <div className={styles["nav-section"]}>
      <div className={styles["nav-section-title"]}>
        <L10n id="header.tab.ai" />
      </div>
      <NavigationButton
        currentView={view}
        desiredView={DashboardView.AI_SETTINGS_GENERAL}
        linkTo={Path.AI_SETTINGS_GENERAL}
        l10nId={"ai.navigation.generalSettings"}
      />
      <NavigationButton
        currentView={view}
        desiredView={DashboardView.AI_SETTINGS_MODEL_CONFIGURATION}
        linkTo={Path.AI_SETTINGS_MODEL_CONFIGURATION}
        l10nId={"ai.navigation.modelConfiguration"}
      />
      <NavigationButton
        currentView={view}
        desiredView={DashboardView.AI_SETTINGS_TESTING}
        linkTo={Path.AI_SETTINGS_TESTING}
        l10nId={"ai.navigation.testing"}
      />
    </div>
  </div>
));
